/* eslint-disable */
import createIcon from '../createIcon';

const IconArrowLeftOutlined = createIcon({
  name: 'icon-arrow-left-outlined',
  content: '<path d="M509.451 827.356l-315.42-315.42 45.051-45.05 315.42 315.42z"/><path d="M554.31 241.503l-315.42 315.42-45.05-45.05 315.42-315.42z"/><path d="M258.07 480.458h637.213v63.721H258.071z"/>',
  width: 1024,
  height: 1024
});
export default IconArrowLeftOutlined;
